import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './claimforms.css'
import axios from 'axios'
import makeData from './data.json'
const ClaimForm = () => {
  const navigate = useNavigate()
  const generateClaimNumber = () => {
    const letters = String.fromCharCode(
      65 + Math.floor(Math.random() * 26),
      65 + Math.floor(Math.random() * 26)
    )
    const numbers = Math.floor(10000000 + Math.random() * 90000000)
    return `${letters}${numbers}`
  }

  const [formData, setFormData] = useState({})
  const [claimNumber, setClaimNumber] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [errors, setErrors] = useState({})
  const [models, setModels] = useState([])
  const [variants, setVariants] = useState([])

  // Validation functions
const validateAlphabets = value => {
  const regex = /^[A-Za-z\s.-]*$/
  return regex.test(value)
}

  const validateGST = value => {
    if (!value) return true // Empty is allowed since it's not required
    const regex = /^[A-Z0-9]*$/
    return regex.test(value)
  }
  const handleChange = e => {
    const { name, value, type, checked } = e.target

    // Clear error
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }))
    }

    // Normal field update first
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }))

    // -------------------------
    // WHEN MAKE CHANGES
    // -------------------------
    if (name === 'make') {
      const selectedMake = makeData.find(item => item.make === value)

      setModels(selectedMake?.models || [])
      setVariants([])

      // Reset Model & Variant in formData
      setFormData(prev => ({
        ...prev,
        model: '',
        variant: ''
      }))
    }

    // -------------------------
    // WHEN MODEL CHANGES
    // -------------------------
    if (name === 'model') {
      const selectedMake = makeData.find(item => item.make === formData.make)
      const selectedModel = selectedMake?.models.find(
        m => m.model_name === value
      )

      setVariants(selectedModel?.variants || [])

      // Reset variant
      setFormData(prev => ({
        ...prev,
        variant: ''
      }))
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()
      // Get logged-in user
  const storedUser = JSON.parse(localStorage.getItem('insuranceUser'))
    console.log("90",storedUser);
    
  if (!storedUser || !storedUser.userId) {
    alert('User not logged in. Please login again.')
    return
  }
    // Final validation before submission
    const finalErrors = {}

    if (formData.workshopName && !validateAlphabets(formData.workshopName)) {
      finalErrors.workshopName = 'Only alphabets are allowed'
    }

    if (formData.workshopCity && !validateAlphabets(formData.workshopCity)) {
      finalErrors.workshopCity = 'Only alphabets are allowed'
    }

    if (formData.workshopGST && !validateGST(formData.workshopGST)) {
      finalErrors.workshopGST = 'Must contain both letters and numbers'
    }

    if (Object.keys(finalErrors).length > 0) {
      setErrors(finalErrors)
      return
    }
    
    setSubmitting(true)
    try {
      const generatedClaimNumber = generateClaimNumber()
      const dataToSubmit = {
        ...formData,
        claimNumber: generatedClaimNumber,
        waterborne: formData.waterborne || 'no',// Default value if not selected
        userId: storedUser.userId 
      }

      console.log('Form Data:', dataToSubmit)

      const res = await axios.post('/process_data/submit', dataToSubmit)

      if (res.data.success) {
        setClaimNumber(generatedClaimNumber)
        setShowModal(true)
        setFormData({})
        setErrors({})
      } else {
        alert('❌ Failed to submit claim: ' + res.data.message)
      }
    } catch (error) {
      console.error('❌ Error submitting claim:', error)
      alert('❌ Server error. Please try again.')
    } finally {
      setSubmitting(false)
    }
  }

  const closeModal = () => {
    setShowModal(false)
  }

  const goToHome = () => {
    setShowModal(false)
    setFormData({})
    navigate('/home')
  }

  const copyClaimNumber = () => {
    if (claimNumber) {
      navigator.clipboard.writeText(claimNumber).then(() => {
        alert('✅ Claim number copied to clipboard!')
      })
    }
  }

  return (
    <div className='claim-form-page'>
      <div className='claim-form-container-regis'>
        <h2 className='heading-regis'>Claim Registration</h2>
        <br />
        {/* <p className="instruction-regis">
          Please enter following details for claim registration (Fields marked with * are mandatory)
        </p> */}
        <form className='claim-form-regis' onSubmit={handleSubmit}>
          <div className='two-column-regis'>
            <fieldset className='fieldset-regis'>
              <legend className='legend-regis'>Policy Details</legend>
              <div className='input-group-regis'>
                <label data-required=''>Policy Number</label>
                <input
                  name='policyNumber'
                  value={formData.policyNumber || ''}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className='input-group-regis'>
                <label>Registration Number</label>
                <input
                  name='registrationNumber'
                  value={formData.registrationNumber || ''}
                  onChange={handleChange}
                />
              </div>
              {/* <div className="input-group-regis">
                <label>Model</label>
                <input
                  name="model"
                  value={formData.model || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="input-group-regis">
                <label>Variant</label>
                <input
                  name="variant"
                  value={formData.variant || ""}
                  onChange={handleChange}
                />
              </div> */}
              <div className='input-group-regis'>
                <label>Make</label>
                <select
                  name='make'
                  value={formData.make || ''}
                  onChange={handleChange}
                >
                  <option value=''>Select Make</option>
                  {makeData.map((make, idx) => (
                    <option key={idx} value={make.make}>
                      {make.make}
                    </option>
                  ))}
                </select>
              </div>

              <div className='input-group-regis'>
                <label>Model</label>
                <select
                  name='model'
                  value={
                    models.some(m => m.model_name === formData.model)
                      ? formData.model
                      : ''
                  }
                  onChange={handleChange}
                  disabled={!formData.make}
                >
                  <option value=''>Select Model</option>
                  {models.map((m, idx) => (
                    <option key={idx} value={m.model_name}>
                      {m.model_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className='input-group-regis'>
                <label>Variant</label>
                <select
                  name='variant'
                  value={
                    variants.some(v => v.variant_name === formData.variant)
                      ? formData.variant
                      : ''
                  }
                  onChange={handleChange}
                  disabled={!formData.model}
                >
                  <option value=''>Select Variant</option>
                  {variants.map((v, idx) => (
                    <option key={idx} value={v.variant_name}>
                      {v.variant_name}
                    </option>
                  ))}
                </select>
              </div>
            </fieldset>

            <fieldset className='fieldset-regis'>
              <legend className='legend-regis'>Customer Details</legend>
              <div className='input-group-regis'>
                <label>Customer Name</label>
                <input
                  name='customerName'
                  value={formData.customerName || ''}
                  onChange={handleChange}
                />
              </div>
              <div className='input-group-regis'>
                <label>Email Id</label>
                <input
                  name='email'
                  value={formData.email || ''}
                  onChange={handleChange}
                />
              </div>
              <div className='input-group-regis'>
                <label data-required=''>Contact Number</label>
                <input
                  name='contactNumber'
                  value={formData.contactNumber || ''}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className='input-group-regis'>
                <label>Claim Coordinator</label>
                <input
                  name='ClaimCoordinator'
                  value={formData.ClaimCoordinator || ''}
                  onChange={handleChange}
                />
              </div>
            </fieldset>
          </div>

          <fieldset className='fieldset-regis'>
            <legend className='legend-regis'>Accident Details</legend>
            <div className='two-column-regis'>
              <div>
                <label data-required=''>
                  Third Party Property/Bodily injury
                </label>
                <div className='radio-group-regis'>
                  <label>
                    <input
                      type='radio'
                      name='bodilyInjury'
                      value='yes'
                      checked={formData.bodilyInjury === 'yes'}
                      onChange={handleChange}
                    />
                    Yes
                  </label>
                  <label>
                    <input
                      type='radio'
                      name='bodilyInjury'
                      value='no'
                      checked={
                        formData.bodilyInjury === 'no' || !formData.bodilyInjury
                      }
                      onChange={handleChange}
                    />
                    No
                  </label>
                </div>
              </div>

              <div className='input-group-regis'>
                <label data-required=''>Accident Date & Time</label>
                <input
                  type='datetime-local'
                  name='accidentDateTime'
                  value={formData.accidentDateTime || ''}
                  onChange={handleChange}
                  max={new Date().toISOString().slice(0, 16)}
                  required
                />
              </div>
            </div>

            <div className='two-column-regis'>
              <div className='input-group-regis'>
                <label data-required=''>Nature of Loss</label>
                <select
                  name='natureOfLoss'
                  value={formData.natureOfLoss || ''}
                  onChange={handleChange}
                  required
                >
                  <option value=''>Select</option>
                  <option value='Collision'>Collision</option>
                  <option value='Fire'>Fire</option>
                  <option value='Theft'>Theft</option>
                </select>
              </div>

              <div className='input-group-regis'>
                <label data-required=''>Damaged Parts</label>
                <input
                  type='text'
                  name='damagedParts'
                  value={formData.damagedParts || ''}
                  onChange={handleChange}
                  required
                  placeholder='Enter damaged parts (e.g., bumper, door)'
                />
              </div>
            </div>

            <div className='input-group-regis'>
              <label data-required=''>Location of Accident</label>
              <input
                name='location'
                value={formData.location || ''}
                onChange={handleChange}
                required
              />
            </div>

            <div className='input-group-regis'>
              <label data-required=''>
                Description of Accident{' '}
                <span className='note-regis'>(Max 1000 characters)</span>
              </label>
              <input
                name='description'
                value={formData.description || ''}
                maxLength={1000}
                onChange={handleChange}
                required
              />
            </div>

            <div className='two-column-regis'>
              <div>
                <label>Was Vehicle Parked at the time of loss?</label>
                <div className='radio-group-regis'>
                  <label>
                    <input
                      type='radio'
                      name='vehicleParked'
                      value='yes'
                      checked={formData.vehicleParked === 'yes'}
                      onChange={handleChange}
                    />
                    Yes
                  </label>
                  <label>
                    <input
                      type='radio'
                      name='vehicleParked'
                      value='no'
                      checked={
                        formData.vehicleParked === 'no' ||
                        !formData.vehicleParked
                      }
                      onChange={handleChange}
                    />
                    No
                  </label>
                </div>
              </div>

              <div className='input-group-regis'>
                <label data-required=''>Driver License Number</label>
                <input
                  name='driverLicense'
                  value={formData.driverLicense || ''}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className='two-column-regis'>
              <div className='input-group-regis'>
                <label>Driver Name</label>
                <input
                  name='driverName'
                  value={formData.driverName || ''}
                  onChange={handleChange}
                />
              </div>
              <div className='input-group-regis'>
                <label data-required=''>
                  Driver's Relationship with Insured
                </label>
                <select
                  name='relationship'
                  value={formData.relationship || ''}
                  onChange={handleChange}
                  required
                >
                  <option value=''>Select</option>
                  <option value='Self'>Self</option>
                  <option value='Spouse'>Spouse</option>
                  <option value='Relative'>Relative</option>
                </select>
              </div>
            </div>

            <legend className='legend-regis'>Workshop Details</legend>
            <div className='workshop-input'>
              <div>
                <label className='depreciation-label'>Waterborne</label>
                <div className='radio-group-regis'>
                  <label>
                    <input
                      type='radio'
                      name='waterborne'
                      value='yes'
                      checked={formData.waterborne === 'yes'}
                      onChange={handleChange}
                    />
                    Yes
                  </label>
                  <label>
                    <input
                      type='radio'
                      name='waterborne'
                      value='no'
                      checked={
                        formData.waterborne === 'no' || !formData.waterborne
                      }
                      onChange={handleChange}
                    />
                    No
                  </label>
                </div>
              </div>
              <div className='input-group-regis'>
                <label data-required=''>Workshop Name</label>
                <input
                  name='workshopName'
                  value={formData.workshopName || ''}
                  onChange={handleChange}
                  placeholder='Enter workshop name'
                  className={errors.workshopName ? 'error' : ''}
                />
                {errors.workshopName && (
                  <span className='error-message'>{errors.workshopName}</span>
                )}
              </div>
              <div className='input-group-regis'>
                <label data-required=''>Workshop City</label>
                <input
                  name='workshopCity'
                  value={formData.workshopCity || ''}
                  onChange={handleChange}
                  placeholder='Enter workshop city'
                  className={errors.workshopCity ? 'error' : ''}
                />
                {errors.workshopCity && (
                  <span className='error-message'>{errors.workshopCity}</span>
                )}
              </div>
              <div className='input-group-regis'>
                <label>Workshop Type</label>
                <select
                  name='workshopType'
                  value={formData.workshopType || ''}
                  onChange={handleChange}
                >
                  <option value=''>Select Workshop Type</option>
                  <option value='Preferred Garage'>Preferred Garage</option>
                  <option value='Multi-Brand'>Multi-Brand</option>
                  <option value='Local Workshop'>Local Workshop</option>
                  <option value='Dealer workshop'>Dealer workshop</option>
                </select>
              </div>

              <div className='input-group-regis'>
                <label data-required=''>Workshop GST Number</label>
                <input
                  name='workshopGST'
                  value={formData.workshopGST || ''}
                  onChange={handleChange}
                  placeholder='Enter GST nos (e.g., 07AABCU9603R1ZM)'
                  maxLength={15}
                  className={errors.workshopGST ? 'error' : ''}
                />
                {errors.workshopGST && (
                  <span className='error-message'>{errors.workshopGST}</span>
                )}
              </div>
            </div>

            <div className='depreciation-policy-section'>
              <label className='depreciation-label'>ADD ONS</label>
              <div className='checkbox-grid-regis'>
                <div className='checkbox-item'>
                  <input
                    type='checkbox'
                    id='zeroDep'
                    name='zeroDep'
                    checked={formData.zeroDep || false}
                    onChange={e => {
                      const { name, checked } = e.target
                      setFormData(prev => {
                        const currentDepreciation =
                          prev.depreciationPolicy || []
                        let updatedDepreciation

                        if (checked) {
                          // Add to array if not already present
                          if (!currentDepreciation.includes('zeroDep')) {
                            updatedDepreciation = [
                              ...currentDepreciation,
                              'zeroDep'
                            ]
                          } else {
                            updatedDepreciation = currentDepreciation
                          }
                        } else {
                          // Remove from array
                          updatedDepreciation = currentDepreciation.filter(
                            item => item !== 'zeroDep'
                          )
                        }

                        return {
                          ...prev,
                          [name]: checked,
                          depreciationPolicy: updatedDepreciation
                        }
                      })
                    }}
                  />
                  <label htmlFor='zeroDep'>Zero Dep</label>
                </div>
                <div className='checkbox-item'>
                  <input
                    type='checkbox'
                    id='consumables'
                    name='consumables'
                    checked={formData.consumables || false}
                    onChange={e => {
                      const { name, checked } = e.target
                      setFormData(prev => {
                        const currentDepreciation =
                          prev.depreciationPolicy || []
                        let updatedDepreciation

                        if (checked) {
                          if (!currentDepreciation.includes('consumables')) {
                            updatedDepreciation = [
                              ...currentDepreciation,
                              'consumables'
                            ]
                          } else {
                            updatedDepreciation = currentDepreciation
                          }
                        } else {
                          updatedDepreciation = currentDepreciation.filter(
                            item => item !== 'consumables'
                          )
                        }

                        return {
                          ...prev,
                          [name]: checked,
                          depreciationPolicy: updatedDepreciation
                        }
                      })
                    }}
                  />
                  <label htmlFor='consumables'>Consumables</label>
                </div>
                <div className='checkbox-item'>
                  <input
                    type='checkbox'
                    id='engineSecure'
                    name='engineSecure'
                    checked={formData.engineSecure || false}
                    onChange={e => {
                      const { name, checked } = e.target
                      setFormData(prev => {
                        const currentDepreciation =
                          prev.depreciationPolicy || []
                        let updatedDepreciation

                        if (checked) {
                          if (!currentDepreciation.includes('engineSecure')) {
                            updatedDepreciation = [
                              ...currentDepreciation,
                              'engineSecure'
                            ]
                          } else {
                            updatedDepreciation = currentDepreciation
                          }
                        } else {
                          updatedDepreciation = currentDepreciation.filter(
                            item => item !== 'engineSecure'
                          )
                        }

                        return {
                          ...prev,
                          [name]: checked,
                          depreciationPolicy: updatedDepreciation
                        }
                      })
                    }}
                  />
                  <label htmlFor='engineSecure'>Engine Secure</label>
                </div>
                <div className='checkbox-item'>
                  <input
                    type='checkbox'
                    id='rti'
                    name='rti'
                    checked={formData.rti || false}
                    onChange={e => {
                      const { name, checked } = e.target
                      setFormData(prev => {
                        const currentDepreciation =
                          prev.depreciationPolicy || []
                        let updatedDepreciation

                        if (checked) {
                          if (!currentDepreciation.includes('rti')) {
                            updatedDepreciation = [
                              ...currentDepreciation,
                              'rti'
                            ]
                          } else {
                            updatedDepreciation = currentDepreciation
                          }
                        } else {
                          updatedDepreciation = currentDepreciation.filter(
                            item => item !== 'rti'
                          )
                        }

                        return {
                          ...prev,
                          [name]: checked,
                          depreciationPolicy: updatedDepreciation
                        }
                      })
                    }}
                  />
                  <label htmlFor='rti'>RTI</label>
                </div>
                <div className='checkbox-item'>
                  <input
                    type='checkbox'
                    id='tyreSecure'
                    name='tyreSecure'
                    checked={formData.tyreSecure || false}
                    onChange={e => {
                      const { name, checked } = e.target
                      setFormData(prev => {
                        const currentDepreciation =
                          prev.depreciationPolicy || []
                        let updatedDepreciation

                        if (checked) {
                          if (!currentDepreciation.includes('tyreSecure')) {
                            updatedDepreciation = [
                              ...currentDepreciation,
                              'tyreSecure'
                            ]
                          } else {
                            updatedDepreciation = currentDepreciation
                          }
                        } else {
                          updatedDepreciation = currentDepreciation.filter(
                            item => item !== 'tyreSecure'
                          )
                        }

                        return {
                          ...prev,
                          [name]: checked,
                          depreciationPolicy: updatedDepreciation
                        }
                      })
                    }}
                  />
                  <label htmlFor='tyreSecure'>Tyre Secure</label>
                </div>
                <div className='checkbox-item'>
                  <input
                    type='checkbox'
                    id='keyProtect'
                    name='keyProtect'
                    checked={formData.keyProtect || false}
                    onChange={e => {
                      const { name, checked } = e.target
                      setFormData(prev => {
                        const currentDepreciation =
                          prev.depreciationPolicy || []
                        let updatedDepreciation

                        if (checked) {
                          if (!currentDepreciation.includes('keyProtect')) {
                            updatedDepreciation = [
                              ...currentDepreciation,
                              'keyProtect'
                            ]
                          } else {
                            updatedDepreciation = currentDepreciation
                          }
                        } else {
                          updatedDepreciation = currentDepreciation.filter(
                            item => item !== 'keyProtect'
                          )
                        }

                        return {
                          ...prev,
                          [name]: checked,
                          depreciationPolicy: updatedDepreciation
                        }
                      })
                    }}
                  />
                  <label htmlFor='keyProtect'>Key Protect</label>
                </div>
              </div>
            </div>
          </fieldset>

          <div className='declaration-regis'>
            <label>
              <input
                type='checkbox'
                name='declaration'
                checked={formData.declaration || false}
                required
                onChange={handleChange}
              />
              I/We, the above named, do hereby, to the best of my/our knowledge
              and belief, warrant the truth of the foregoing statements in every
              respect; and I/we agree that if I/We have made, or in any further
              declaration, the Company may require in respect of the said
              accident, shall make any false or fraudulent statement, or any
              suppression or concealment, the Company may forfeit the entire
              claim, and the Policy shall be null and void.
            </label>
          </div>

          <button
            type='submit'
            className='submit-button-regis'
            disabled={submitting}
          >
            {submitting ? 'Submitting...' : 'Submit'}
          </button>
        </form>
      </div>

      {/* Modal Popup */}
      {showModal && (
        <div className='modal-overlay'>
          <div className='modal-content'>
            <h3>Claim Generated!</h3>
            <p>Your Claim Number is:</p>
            <h2>{claimNumber}</h2>
            <div className='modal-buttons'>
              <button onClick={copyClaimNumber} className='copy-button'>
                Copy
              </button>
              <button onClick={closeModal} className='close-button'>
                Close
              </button>
              <button onClick={goToHome} className='home-button'>
                Go to Home
              </button>
              {/* <button onClick={() => navigate(`/claimlanding/${claimNumber}`)} className="claim-landing-button">Click Here</button> */}
            </div>
            <div className='claim-link-container'>
              <p>Claim Link:</p>
              <a
                href={`/claimlanding/${claimNumber}`}
                className='claim-link'
                target='_blank'
                rel='noopener noreferrer'
              >
                {window.location.origin}/claimlanding/{claimNumber}
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default ClaimForm
